/**
 * l2-drawer-sub — Convierte una línea del carrito a suscripción desde su barra discreta.
 * La barra (en cart-products.liquid, bajo cada producto elegible) lleva data-key, data-plan y
 * data-qty. Al hacer clic, cambia esa línea a su selling_plan vía /cart/change.js. La capa
 * l2-cart-sync detecta el cambio y re-renderiza el drawer (la barra desaparece porque la línea
 * ya es suscripción). Handler delegado en document → sobrevive a los re-render del carrito.
 */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-l2subline]');
  if (!btn || btn.dataset.busy) return;

  const key = btn.getAttribute('data-key');
  const plan = btn.getAttribute('data-plan');
  const qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
  if (!key || !plan) return;

  btn.dataset.busy = '1';
  btn.classList.add('is-loading');
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');
  const error = btn.closest('.l2subline-cell').querySelector('.l2subline__error');
  if (error) error.hidden = true;
  const errorMessage = document.documentElement.lang?.startsWith('fr')
    ? 'Impossible d’activer l’abonnement. Veuillez réessayer.'
    : 'No se pudo activar la suscripción. Inténtalo de nuevo.';

  try {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: qty, selling_plan: plan }),
    });
    if (!response.ok) throw new Error(errorMessage);
    // l2-cart-sync re-renderiza el drawer; la barra desaparece al ser ya suscripción.
  } catch (_) {
    if (error) { error.textContent = errorMessage; error.hidden = false; }
  } finally {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.classList.remove('is-loading');
    delete btn.dataset.busy;
  }
});
